
<template>
  <div>
    <HeadVue></HeadVue>
    <iframe src="http://60.172.131.22:5700" style="width: 100%; height: calc(100vh - 300px);"></iframe>
    <FooterVue style="margin-top: 0"></FooterVue>
  </div>

</template>
<script>
import HeadVue from "@/views/common/HeadVue.vue";
import FooterVue from "@/views/common/FooterVue.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  components: {FooterVue, HeadVue}
}
</script>
<style scoped lang="css">

</style>